import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	max-width: 18.688rem;
	min-width: 16rem;
	padding-bottom: 8px;
	max-height: 55vh;
`;

export const Header = styled.div`
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Banner = styled.img`
	width: 100%;
	height: 9.96rem;
	border-radius: 0.5rem;
`;

export const Title = styled.label`
	color: var(--neutral-smoothest, #fff);

	font-family: var(--font-family-metropolis-regular);
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%;
`;

export const Price = styled.span`
	display: flex;
	padding: 4px 8px;
	align-items: center;
	gap: 4px;

	border-radius: 4px;
	border: 1px solid var(--neutral-strong, #353546);

	color: var(--brand-primary, #01e59b);
	font-family: var(--font-family-metropolis-regular);
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 170%;
`;

export const WithoutImage = styled.div`
	background-color: var(--neutral-strong);
	height: 21.5rem;
	border-radius: 1rem;

	&::before {
		content: " ";
	}
`;

export const Footer = styled.div`
	display: flex;
	gap: 8px;
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const RadioBox = styled.input``;

export const LabelBox = styled.label`
	color: var(--neutral-smoothest, #fff);

	font-family: var(--font-family-metropolis-regular);
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 170%;
	cursor: pointer;

	margin: 0;
`;
